import { createColumnHelper } from "@tanstack/react-table";
import { IOperatorLicenses } from "./utils/HEOperatorCertificateType-utils";
import HEOperatorCertificateTypeActionsButton from "./utils/HEOperatorCertificateTypeActionsButtons";
import Chip from "@mui/material/Chip";
import { usePermission } from "../../../../hooks/usePermissions";
import { Modules, Permissions } from "../../../Users/Roles/roles-utils";

const columnHelper = createColumnHelper<IOperatorLicenses>();

const HEOperatorLinceseTypeColumn = () => {
  const hasEditPermission = usePermission(
    Modules.mmdOc.accessKey,
    Permissions.edit
  );
  const hasDeletePermission = usePermission(
    Modules.mmdOc.accessKey,
    Permissions.delete
  );

  return [
    columnHelper.accessor("id", {
      id: "id",
      header: "Item No",
      cell: ({ row }) => row.index + 1,
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("name", {
      id: "name",
      header: "Name",
      cell: (row) => row.renderValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("operatorType", {
      id: "operatorType",
      header: "Operator Type",
      cell: (row) => row.renderValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("validity", {
      id: "validity",
      header: "Validity",
      cell: (row) => row.renderValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("isActive", {
      id: "isActive",
      header: "Status",
      cell: (row) => (
        <Chip
          label={row.getValue() ? "Active" : "Inactive"}
          color={row.getValue() ? "primary" : "warning"}
          style={{ color: row.getValue() ? "white" : "white", height: "25px" }}
        />
      ),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    ...(hasEditPermission || hasDeletePermission
      ? [
          columnHelper.display({
            id: "actions",
            header: "Action",
            cell: ({ row }) => (
              <HEOperatorCertificateTypeActionsButton
                IOperatorLicenses={row.original}
                hasEditPermission={hasEditPermission}
                hasDeletePermission={hasDeletePermission}
              />
            ),
            enableHiding: false,
          }),
        ]
      : []),
  ];
};

export default HEOperatorLinceseTypeColumn;
